"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServicesHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section ref={ref} className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-dark-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1496898/img/cyber_cityscape_holographic_code_overlay.png)] opacity-60" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-b from-primary/20 via-transparent to-dark-background/80" />

      {}
      <div className={`relative z-10 max-w-4xl mx-auto px-4 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        {}
        <h1 className="font-display text-5xl md:text-7xl font-bold text-foreground-dark mb-6 drop-shadow-[0_0_24px_rgba(59,130,246,0.8)]">
          Architecture That <span className="text-primary">Remixes</span> Your Workflow
        </h1>

        {}
        <p className={`text-lg md:text-xl text-foreground-dark/90 mb-10 max-w-2xl mx-auto transition-all delay-100 duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          AI-driven automation systems that eliminate administrative friction for dance studios and nonprofits. Reclaim your time. Focus on creativity.
        </p>

        {}
        <Button asChild size="lg" className="bg-primary hover:bg-primary-hover text-foreground-primary font-semibold px-8 py-6 text-lg rounded-md shadow-[0_0_20px_rgba(59,130,246,0.4)] hover:shadow-[0_0_32px_rgba(59,130,246,0.7)] hover:scale-[1.04] transition-all duration-[80ms] ease-[var(--ease-spring)] focus-ring">
          <Link to="/AuditPage">Book Your Strategy Audit</Link>
        </Button>
      </div>
    </section>;
}